import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Select from '../../../shared/reactSelect/select.component';
import FormControl from '../../../shared/forms/formControl.component';
import { OptionsPropType } from '../../../shared/propTypes/common';

class ParamSelect extends PureComponent {
  static propTypes = {
    updateQueryParams: PropTypes.func.isRequired,
    queryParam: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    mappingName: PropTypes.string.isRequired,
    options: OptionsPropType,
  };

  selectParam = ({ value }) => {
    this.props.updateQueryParams({ [this.props.name]: value });
  };

  render() {
    const {
      queryParam,
      name,
      mappingName,
      options,
    } = this.props;

    return (
      <FormControl
        onChange={this.selectParam}
        name={name}
        label={mappingName}
        value={queryParam}
        horizontal
      >
        <Select
          key={name}
          clearable={false}
          options={options}
          labelKey="value"
          virtualized
        />
      </FormControl>
    );
  }
}

export default ParamSelect;
